export default "/images/dropdown-arrow-down.svg?c7c05287f277c24023ea3070e08bcfc5";